import React from 'react';

// Components
import GlobalConfigProvider from 'components/GlobalConfigProvider';
import EntityTypesProvider from 'components/EntityTypesProvider';
import AuthFetcher from './AuthFetch';
import AppFetches from './AppFetches';

interface Props {
  authentication: any;
  siftBotStatus: any;
  authStatus: any;
  clientStatus: any;
  children: (shouldLoadApp: boolean) => any;
}

function AppFetcher(props: Props) {
  const { authentication, authStatus, siftBotStatus, clientStatus, children } = props;

  return (
    <AuthFetcher authStatus={authStatus} authentication={authentication}>
      {() => (
        <AppFetches siftBotStatus={siftBotStatus} clientStatus={clientStatus}>
          {loaded => {
            if (!loaded) return children(false);

            // TODO (Rico): this is weird, refactor this later
            // NOTE: these providers need to be after the `<AppFetches />`
            return (
              <EntityTypesProvider>
                <GlobalConfigProvider>{children(true)}</GlobalConfigProvider>
              </EntityTypesProvider>
            );
          }}
        </AppFetches>
      )}
    </AuthFetcher>
  );
}

export default AppFetcher;
